import {
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Button,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { errorToast } from "components/toast";
import { successToast } from "components/toast";
import { FormControlLabel, Switch } from "@mui/material";
import Pagination from "components/Pagination";
import { getUsersDataList } from "services/_user";
import { updateUserStatus } from "services/_user";
import { deleteUserById } from "services/_user";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { updateUserPassword } from "services/_user";

const UserList = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const createUser = () => {
    navigate("/admin/users/create-user");
  };

  const initialData = useCallback(async () => {
    let payload = `page=${page}&per_page=${perPage}`;
    const data = await getUsersDataList(payload);
    if (data.data) {
      setRecords(data.data.records || []);
      setUserData(data.data.records);
      setTotalRecords(data.data.total_records || 0);

      if (data.data.total_records && perPage) {
        setTotalPages(Math.ceil(data.data.total_records / perPage));
      }
    }
  }, [page, perPage]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  const handleEdit = async (id) => {
    navigate(`/admin/users/edit-user/${id}`);
  };

  const handleDelete = async (id) => {
    const data = await deleteUserById({ id });
    if (data.data) {
      successToast(data.message);
      initialData();
    } else {
      errorToast(data.message);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      // Call your API to update the status
      const payload = { id, status: newStatus };
      const response = await updateUserStatus(payload);

      if (response.data) {
        successToast(response.message);

        setUserData((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, status: newStatus } : item
          )
        );
      } else {
        errorToast(response.message);
      }
    } catch (err) {
      console.error(err);
      errorToast("Something went wrong!");
    }
  };

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogOpen = (id) => {
    setSelectedUserId(id);
    setOpen(true);
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between">
                <h3>Users</h3>
                <Button color="info" onClick={createUser}>
                  Create
                </Button>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Status</th>
                    <th scope="col">Created At</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {userData.length > 0 ? (
                    userData.map((user, index) => (
                      <tr key={index}>
                        <th scope="row">{(page - 1) * perPage + index + 1}</th>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{user.phone_no}</td>
                        <td>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={user.status}
                                onChange={() =>
                                  handleStatusChange(user.id, !user.status)
                                }
                              />
                            }
                          />
                        </td>
                        <td>
                          {user.created_at
                            ? moment(user.created_at).format("DD MMMM, YYYY")
                            : "-"}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <UncontrolledDropdown>
                            <DropdownToggle
                              className="btn-icon-only text-light"
                              href="#pablo"
                              role="button"
                              size="sm"
                              color=""
                              onClick={(e) => e.preventDefault()}
                            >
                              <i className="fas fa-ellipsis-v" />
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-arrow" right>
                              <DropdownItem onClick={() => handleEdit(user.id)}>
                                <i
                                  className="fas fa-edit"
                                  style={{
                                    color: "#1976d2",
                                    cursor: "pointer",
                                    marginRight: "10px",
                                  }}
                                ></i>
                                Edit
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => handleDelete(user.id)}
                              >
                                <i
                                  className="fas fa-trash"
                                  style={{
                                    color: "red",
                                    cursor: "pointer",
                                    marginRight: "10px",
                                  }}
                                ></i>
                                Delete
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => handleDialogOpen(user.id)}
                              >
                                <i
                                  className="ni ni-lock-circle-open"
                                  style={{
                                    color: "green",
                                    cursor: "pointer",
                                    marginRight: "10px",
                                  }}
                                ></i>
                                change password
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>No record found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <Pagination
                  page={page}
                  perPage={perPage}
                  totalRecords={totalRecords}
                  totalPages={totalPages}
                  records={records}
                  prevButton={prevButton}
                  nextButton={nextButton}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
          <DialogTitle>Update Password</DialogTitle>
          <Formik
            initialValues={{
              newPassword: "",
              confirmPassword: "",
            }}
            validationSchema={Yup.object().shape({
              newPassword: Yup.string()
                .required("New Password is required")
                .matches(
                  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
                  "Password must be at least 8 characters, include 1 uppercase letter, 1 number, and 1 special character"
                ),
              confirmPassword: Yup.string()
                .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
                .required("Confirm Password is required"),
            })}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                const payload = {
                  password: values.newPassword,
                  confirm_password: values.confirmPassword,
                  id: selectedUserId,
                };
                const data = await updateUserPassword(payload);
                if (data.isSuccess) {
                  successToast(data.message);
                  setOpen(false);
                  setSelectedUserId(null);
                } else {
                  errorToast(data.message);
                }
              } catch (err) {
                errorToast("Something went wrong!");
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit} id="subscription-form">
                <DialogContent>
                  <TextField
                    required
                    margin="dense"
                    id="newPassword"
                    name="newPassword"
                    label="New Password"
                    type="password"
                    fullWidth
                    variant="standard"
                    value={values.newPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.newPassword && Boolean(errors.newPassword)}
                    helperText={touched.newPassword && errors.newPassword}
                  />
                  <TextField
                    required
                    margin="dense"
                    id="confirmPassword"
                    name="confirmPassword"
                    label="Confirm Password"
                    type="password"
                    fullWidth
                    variant="standard"
                    value={values.confirmPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.confirmPassword && Boolean(errors.confirmPassword)
                    }
                    helperText={
                      touched.confirmPassword && errors.confirmPassword
                    }
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleClose}
                    style={{
                      width: "100%",
                      backgroundColor: "red",
                      color: "white",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    style={{
                      width: "100%",
                      color: "white",
                      backgroundColor: "green",
                    }}
                  >
                    Save
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </Dialog>
      </Container>
    </>
  );
};

export default UserList;
